import React from 'react';
import { Link } from 'react-router-dom';
import { LOGO_URL } from '../mock';

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(201,162,75,0.16)] mt-24 bg-[#0A0A0B]">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Talas" className="h-10 w-10 rounded object-contain" />
              <span className="font-logo font-bold text-[#F1ECDF]">TALAS <span className="gold-text">TRADING CO</span></span>
            </div>
            <p className="text-sm text-[#CDBE94] mt-4 max-w-md leading-relaxed">
              Subscriber platform for structured automated execution. Built for operators who treat risk as infrastructure, not an afterthought.
            </p>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-[#F1ECDF] mb-4 font-mono">Platform</h4>
            <ul className="space-y-3 text-sm text-[#CDBE94]">
              <li><Link to="/" className="hover:gold-text">Home</Link></li>
              <li><Link to="/signup" className="hover:gold-text">Sign Up Free</Link></li>
              <li><Link to="/login" className="hover:gold-text">Log In</Link></li>
              <li><Link to="/dashboard" className="hover:gold-text">Dashboard</Link></li>
              <li><Link to="/features" className="hover:gold-text">Features</Link></li>
              <li><Link to="/how-it-works" className="hover:gold-text">How It Works</Link></li>
              <li><Link to="/pricing" className="hover:gold-text">Pricing</Link></li>
              <li><Link to="/faq" className="hover:gold-text">FAQ</Link></li>
              <li><Link to="/about" className="hover:gold-text">About</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-[#F1ECDF] mb-4 font-mono">Beta & Legal</h4>
            <ul className="space-y-3 text-sm text-[#CDBE94]">
              <li><Link to="/risk-disclosure" className="hover:gold-text">Risk Disclosure</Link></li>
              <li><Link to="/privacy-policy" className="hover:gold-text">Privacy Policy</Link></li>
              <li><Link to="/terms-of-use" className="hover:gold-text">Terms of Use</Link></li>
              <li><Link to="/contact" className="hover:gold-text">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-[rgba(201,162,75,0.16)] flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs" style={{ color: '#A99563' }}>© {new Date().getFullYear()} Talas Trading Co. All rights reserved.</p>
          <p className="text-xs font-mono" style={{ color: '#A99563' }}>BETA · PAPER ONLY · v1.0</p>
        </div>
      </div>
    </footer>
  );
}
